import "./AnalyticsFaster.css";
import { useState, useEffect } from "react";

export default function AnalyticsFaster() {
  const [current, setCurrent] = useState(0);
  const [cardsPerView, setCardsPerView] = useState(
    typeof window !== "undefined" && window.innerWidth < 576 ? 1 : 2
  );

  useEffect(() => {
    const handleResize = () => {
      const newCardsPerView = window.innerWidth < 576 ? 1 : 2;
      setCardsPerView(newCardsPerView);
      setCurrent(0);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const cards = [
    { cls: "div1" },
    { cls: "div2" },
    { cls: "div3" },
    { cls: "div7" },
    { cls: "div8" },
    { cls: "div9" },
    { cls: "div10" },
    { cls: "div11" },
    { cls: "div12" },
  ];

  const totalSlides = cards.length - cardsPerView + 1;
  const isPrevDisabled = current === 0;
  const isNextDisabled = current === totalSlides - 1;

  const prev = () => { if (!isPrevDisabled) setCurrent((p) => p - 1); };
  const next = () => { if (!isNextDisabled) setCurrent((p) => p + 1); };

  return (
    <div id="analytics-faster" className="outsourcemainclass">
      <h2 className="heading">
        Data & Analytics Services Powering Smarter, Faster Decisions
      </h2>
      <p className="subheading">
        We transform complex data into actionable insights using advanced
        analytics and AI for confident, data-driven decisions.
      </p>

      <div className="cards">
        <div className="div1 card">
          <h3>Data Strategy and Consulting</h3>
          <p>Our data strategy consulting reduces costs, improves data quality, and delivers faster insights to drive innovation and agility.</p>
        </div>
        <div className="div2 card">
          <h3>Data Strategy and Consulting</h3>
          <p>Our data strategy consulting reduces costs, improves data quality, and delivers faster insights to drive innovation and agility.</p>
        </div>
        <div className="div3 card wide">
        <div className="content">
            <h3>Data Strategy and Consulting</h3>
          <p>Our data strategy consulting reduces costs, improves data quality, and delivers faster insights to drive innovation and agility.</p>
        </div>
        </div>
        <div className="div7 card wide">
          <h3>Data Strategy and Consulting</h3>
          <p>Our data strategy consulting reduces costs, improves data quality, and delivers faster insights to drive innovation and agility.</p>
        </div>
        <div className="div8 card">
          <h3>Data Strategy and Consulting</h3>
          <p>Our data strategy consulting reduces costs, improves data quality, and delivers faster insights to drive innovation and agility.</p>
        </div>
        <div className="div9 card">
          <h3>Data Strategy and Consulting</h3>
          <p>Our data strategy consulting reduces costs, improves data quality, and delivers faster insights to drive innovation and agility.</p>
        </div>
        <div className="div10 card">
          <h3>Data Strategy and Consulting</h3>
          <p>Our data strategy consulting reduces costs, improves data quality, and delivers faster insights to drive innovation and agility.</p>
        </div>
        <div className="div11 card">
          <h3>Data Strategy and Consulting</h3>
          <p>Our data strategy consulting reduces costs, improves data quality, and delivers faster insights to drive innovation and agility.</p>
        </div>
        <div className="div12 card wide">
          <h3>Data Strategy and Consulting</h3>
          <p>Our data strategy consulting reduces costs, improves data quality, and delivers faster insights to drive innovation and agility.</p>
        </div>
      </div>

      <div className="cards-carousel">
        <div
          className="carousel-track"
          style={{
            transform: `translateX(calc(-${current * (100 / cardsPerView)}% - ${current * (20 / cardsPerView)}px))`,
          }}
        >
          {cards.map((card, i) => (
            <div key={i} className={`${card.cls} card carousel-card`}>
              <h3>Data Strategy and Consulting</h3>
              <p>
                Our data strategy consulting reduces costs, improves data
                quality, and delivers faster insights to drive innovation
                and agility.
              </p>
            </div>
          ))}
        </div>

        <div className="carousel-controls">
          <button
            className={`carousel-btn${isPrevDisabled ? " disabled" : ""}`}
            onClick={prev}
            disabled={isPrevDisabled}
          >
            &#8592;
          </button>
          <div className="carousel-dots">
            {Array.from({ length: totalSlides }).map((_, i) => (
              <span
                key={i}
                className={`dot${i === current ? " active" : ""}`}
                onClick={() => setCurrent(i)}
              />
            ))}
          </div>
          <button
            className={`carousel-btn${isNextDisabled ? " disabled" : ""}`}
            onClick={next}
            disabled={isNextDisabled}
          >
            &#8594;
          </button>
        </div>
      </div>
    </div>
  );
}